<template lang="pug">
    .goToTodayBtn(ref="btn" :class="{show}" v-anchor="todaySelector" :data-anchor-offset="-deviseHeight/3") {{$t('other.toCurrentDay')}}
</template>

<script>
    export default {
        name: "GoToTodayBtn",
        data:()=>({
            todaySelector: '.home .date.today',
            deviseHeight: null,
            todayInScreen: false,
        }),
        computed:{
            show(){
                return !this.todayInScreen;
            }
        },
        methods:{
            handler(){
                const today = document.querySelector(this.todaySelector);
                if (today.getBoundingClientRect().top > 0 && today.getBoundingClientRect().top < this.deviseHeight){
                    this.todayInScreen = true;
                }else{
                    this.todayInScreen = false;
                }
            },
            updatePosition(){
                let btn = this.$refs.btn;
                this.deviseHeight = document.documentElement.clientHeight;
                btn.style.top = this.deviseHeight - btn.offsetHeight - this.deviseHeight *0.05 + 'px'
            }
        },
        mounted() {
            this.updatePosition();
            window.addEventListener('resize',this.updatePosition, 50);

            window.addEventListener('scroll', this.handler);
        },
        beforeDestroy(){
            window.removeEventListener('scroll', this.handler);
        },
    }
</script>

<style scoped lang="scss">
    .goToTodayBtn{
        position: fixed;
        left: 50%;
        z-index: 10;
        font-size: 1.25rem;
        cursor: pointer;
        &:before{
            content: '';
            display: block;
            position: absolute;
            top: -0.3rem;
            left: -2rem;
            right: -2rem;
            bottom: -0.25rem;
            z-index: -1;
            transform: skewX(-17deg);
            background: red;
        }

        opacity: 0;
        transform: translate(-50%, 100%);
        transition: .5s;
        &.show{
            opacity: 1;
            transform: translate(-50%, 0);
        }
    }
</style>